import { connect } from 'react-redux';
import Header from '../components/Header';

function mapStateToProps(state) {
    return {
        texts: {
            'header.icon.back': state.app.texts['header.icon.back'],
            'header.icon.language': state.app.texts['header.icon.language'],
            'header.icon.menu': state.app.texts['header.icon.menu'],
        },
    };
}

function mapDispatchToProps(dispatch) {
    return {};
}

const HeaderContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(Header);

export default HeaderContainer;
